import type { AxiosInstance } from 'axios';

import { BiddingSummaryTypes } from './types';

export const fetchBiddingSummary = (biddingId: number) => ({
  types: [
    BiddingSummaryTypes.FETCH_BIDDING_SUMMARY_REQUEST,
    BiddingSummaryTypes.FETCH_BIDDING_SUMMARY_SUCCESS,
    BiddingSummaryTypes.FETCH_BIDDING_SUMMARY_FAILURE,
  ],
  biddingId,
  promise: (client: AxiosInstance) =>
    client.get('/chatbots/bidding_chat/bidding_summary', {
      params: { conlicitacao_id: biddingId },
    }),
});

export const fetchBidderConsideration = (biddingId: number) => ({
  types: [
    BiddingSummaryTypes.FETCH_BIDDER_CONSIDERATION_REQUEST,
    BiddingSummaryTypes.FETCH_BIDDER_CONSIDERATION_SUCCESS,
    BiddingSummaryTypes.FETCH_BIDDER_CONSIDERATION_FAILURE,
  ],
  biddingId,
  promise: (client: AxiosInstance) =>
    client.get('/minhas_licitacoes/bidder_considerations', {
      params: { bidding_id: biddingId },
    }),
});

export const fetchBidderConsiderationTeam = (biddingId: number) => ({
  types: [
    BiddingSummaryTypes.FETCH_BIDDER_CONSIDERATION_TEAM_REQUEST,
    BiddingSummaryTypes.FETCH_BIDDER_CONSIDERATION_TEAM_SUCCESS,
    BiddingSummaryTypes.FETCH_BIDDER_CONSIDERATION_TEAM_FAILURE,
  ],
  biddingId,
  promise: (client: AxiosInstance) =>
    client.get('/minhas_licitacoes/bidder_considerations/team', {
      params: { bidding_id: biddingId },
    }),
});

export const saveBidderConsideration = (biddingId: number, consideration: string) => ({
  types: [
    BiddingSummaryTypes.SAVE_BIDDER_CONSIDERATION_REQUEST,
    BiddingSummaryTypes.SAVE_BIDDER_CONSIDERATION_SUCCESS,
    BiddingSummaryTypes.SAVE_BIDDER_CONSIDERATION_FAILURE,
  ],
  biddingId,
  promise: (client: AxiosInstance) =>
    client.post('/minhas_licitacoes/bidder_considerations', {
      bidder_consideration: {
        bidding_id: biddingId,
        consideration,
      },
    }),
});

export const deleteBidderConsideration = (biddingId: number) => ({
  types: [
    BiddingSummaryTypes.DELETE_BIDDER_CONSIDERATION_REQUEST,
    BiddingSummaryTypes.DELETE_BIDDER_CONSIDERATION_SUCCESS,
    BiddingSummaryTypes.DELETE_BIDDER_CONSIDERATION_FAILURE,
  ],
  biddingId,
  promise: (client: AxiosInstance) =>
    client.post('/minhas_licitacoes/bidder_considerations/remove', {
      bidding_id: biddingId,
    }),
});
